import { useI18n } from "../i18n";

// Two-language toggle that mirrors ThemeToggle's shape so the header controls
// read as one set. Shows the active language; the label describes the switch.
export default function LanguageToggle() {
  const { lang, setLang, t } = useI18n();
  const isEnglish = lang === "en";

  return (
    <button
      className="btn btn-ghost btn-circle btn-sm font-display text-xs font-bold tracking-wide"
      onClick={() => setLang(isEnglish ? "es" : "en")}
      aria-label={isEnglish ? t("lang.toSpanish") : t("lang.toEnglish")}
    >
      {lang.toUpperCase()}
    </button>
  );
}
